import { StudentsList } from 'presentation/app/modules/Persons/Students/pages/students-list';
import React from 'react';

export const MakeStudentsList: React.FC = () => {
  return <StudentsList />;
};
